import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-tag_three",
  "use": "icon-tag_three-usage",
  "viewBox": "0 0 28 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 16\" id=\"icon-tag_three\"><g fill-rule=\"nonzero\" fill=\"none\"><rect fill=\"#1890FF\" width=\"28\" height=\"16\" rx=\"2\" /><path d=\"M12.84 5.09V4.07H5.18v1.02h7.66Zm-.69 3.42V7.49H5.86v1.02h6.29Zm1.39 3.7v-1.04H4.46v1.04h9.08Zm5.92.44v-3.1h2.36v.48h1V3.7h-7.64v6.33h1v-.48h2.28v3.1h1Zm-1-6.51h-2.28V4.68h2.28v1.46Zm3.36 0h-2.36V4.68h2.36v1.46Zm-3.36 2.44h-2.28V7.11h2.28v1.47Zm3.36 0h-2.36V7.11h2.36v1.47Z\" fill=\"#FFF\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol